export default {
    SMS: {
        title: 'סמס',
        keys: {
            invFriend: { title: 'הזמן חבר', dynamics: { $d: 'שם המוזמן', $a: 'שם המזמין', $b: 'לינק לאתר' } },
            agentInvite: {
                title: 'הזמנת סוכן - לקוח חדש',
                dynamics: { $d: 'שם הסוכן', $a: 'קוד אימות', $b: 'לינק לאתר' }
            },
            agentInvExist: { title: 'הזמנת סוכן - לקוח קיים', dynamics: { $d: 'שם הסוכן', $a: 'לינק לאתר' } },
            agentResendNew: {
                title: 'סוכן הזמנה חוזרת - לקוח חדש',
                dynamics: { $d: 'שם הסוכן', $a: 'קוד אימות', $b: 'לינק לאתר' }
            },
            agentResendExist: { title: 'סוכן הזמנה חוזרת - לקוח קיים', dynamics: { $d: 'שם הסוכן', $a: 'לינק לאתר' } },
            caseClosed: { title: 'סיום טיפול בפנייה', dynamics: { $d: 'לינק לאתר' } },
            caseOpened: { title: 'פניה התקבלה', dynamics: { $d: 'שירות' } },
            orderFailed: { title: 'זימון תור נכשל' },
            failedPayment: { title: 'תשלום נכשל - שלם שנית' },
            precedeFailed: { title: 'הקדמת תור נכשלה' },
            updateCustomer: { title: 'בקשה בטיפול' },
            clinicAppointment: { title: 'תור למרפאה', dynamics: { $a: 'מרפאה', $b: 'תאריך', $c: 'שעה', $d: 'כתובת' } },
            doctorAppointment: { title: 'תור לרופא', dynamics: { $a: 'רופא', $b: 'תאריך', $c: 'שעה', $d: 'כתובת' } },
            canceledAppointment: { title: 'בקשה בוטלה לאחר 5 שעות' },
            subscriptionExpired: { title: 'מנוי בוטל' },
            askForMoreInformation: { title: 'בקשת פרטים נוספים', dynamics: { $d: 'תגובה' } },
            agentProvidedSub: {
                title: 'סוכן קנה 360 ללקוח',
                dynamics: { $d: 'שם לקוח', $a: 'שם סוכן', $b: 'לינק לpdf' }
            },
            clientAgreement: { title: 'תופס ה',  dynamics: {$a: 'שם הסוכן', $l: 'לינק לאתר'} },
            agreementResolved: { title: 'תופס נחתם', dynamics: {$a: 'שם הלקוח' } }
        }
    },
    SUBSCRIPTION: {
        title: 'מנוי',
        keys: {
            title1: { title: 'כותרת מנוי - 1' },
            desc1: { title: 'תיאור מנוי - 1' },
            title2: { title: 'כותרת מנוי - 2' },
            desc2: { title: 'תיאור מנוי - 2' },
            title3: { title: 'כותרת מנוי - 3' },
            desc3: { title: 'תיאור מנוי - 3' },
            title4: { title: 'כותרת מנוי - 4' },
            desc4: { title: 'תיאור מנוי - 4' },
            title5: { title: 'כותרת מנוי - 5' },
            desc5: { title: 'תיאור מנוי - 5' },
            title6: { title: 'כותרת מנוי - 6' },
            desc6: { title: 'תיאור מנוי - 6' },
            title7: { title: 'כותרת מנוי - 7' },
            desc7: { title: 'תיאור מנוי - 7' },
            title8: { title: 'כותרת מנוי - 8' },
            desc8: { title: 'תיאור מנוי - 8' },
            title9: { title: 'כותרת מנוי - 9' },
            desc9: { title: 'תיאור מנוי - 9' },
            title10: { title: 'כותרת מנוי - 10' },
            desc10: { title: 'תיאור מנוי - 10' },
            title11: { title: 'כותרת מנוי - 11' },
            desc11: { title: 'תיאור מנוי - 11' },
            title13: { title: 'כותרת מנוי - 13' },
            desc13: { title: 'תיאור מנוי - 13' },
            title14: { title: 'כותרת מנוי - 14' },
            desc14: { title: 'תיאור מנוי - 14' },
            title15: { title: 'כותרת מנוי - 15' },
            desc15: { title: 'תיאור מנוי - 15' },
            title16: { title: 'כותרת מנוי - 16' },
            desc16: { title: 'תיאור מנוי - 16' },
            title17: { title: 'כותרת מנוי - 17' },
            desc17: { title: 'תיאור מנוי - 17' },
            title18: { title: 'כותרת מנוי - 18' },
            desc18: { title: 'תיאור מנוי - 18' },
            title19: { title: 'כותרת מנוי - 19' },
            desc19: { title: 'תיאור מנוי - 19' },
            title20: { title: 'כותרת מנוי - 20' },
            desc20: { title: 'תיאור מנוי - 20' },
            title21: { title: 'כותרת מנוי - 21' },
            desc21: { title: 'תיאור מנוי - 21' },
            title22: { title: 'כותרת מנוי - 22' },
            desc22: { title: 'תיאור מנוי - 22' },
            title23: { title: 'כותרת מנוי - 23' },
            desc23: { title: 'תיאור מנוי - 23' }
        }
    },
    SERVICE: {
        title: 'שירות',
        keys: {
            service1: { title: 'שירות 1' },
            service2: { title: 'שירות 2' },
            service3: { title: 'שירות 3' },
            service4: { title: 'שירות 4' },
            service5: { title: 'שירות 5' },
            service6: { title: 'שירות 6' },
            service7: { title: 'שירות 7' },
            service8: { title: 'שירות 8' },
            service9: { title: 'שירות 9' },
            service10: { title: 'שירות 10' },
            service11: { title: 'שירות 11' },
            service12: { title: 'שירות 12' }
        }
    }
}
